module.exports = __webpack_public_path__ + "img/restrict.d9af90f3.png";